import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import {
  SubHeaderWrapper,
  SubHeaderNavList,
  SubHeaderNavListItem,
  SubHeaderNavListLink,
} from './AddressDetailsSubHeader.elements'

function AddressDetailsSubHeader(props) {
  // Hooks
  const { page, setPage } = props

  return (
    <SubHeaderWrapper>
      <SubHeaderNavList>
        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 0 && 'active'}
            onClick={() => {
              setPage(0)
            }}
          >
            Summary
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>

        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 1 && 'active'}
            onClick={() => {
              setPage(1)
            }}
          >
            Linkage
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>

        {/* <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 2 && 'active'}
            onClick={() => {
              setPage(2)
            }}
          >
            Notes
          </SubHeaderNavListLink>
        </SubHeaderNavListItem> */}
      </SubHeaderNavList>
    </SubHeaderWrapper>
  )
}

// Default Props
AddressDetailsSubHeader.defaultProps = {
  page: 0,
  setPage: () => {},
}

// Proptypes Validation
AddressDetailsSubHeader.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func,
}
export default AddressDetailsSubHeader
